export default __webpack_public_path__ + "static/media/cover.52c6cd42.png";